import wixLocation from 'wix-location';
import { copyToClipboard, referrer, rendering, formFactor } from 'wix-window';
import wixSite from 'wix-site';
import wixWindow from 'wix-window';
import wixData from 'wix-data'

import { linkText, linkTextInner, makeResponsive, runOpacityHoverEffect, changeTextColor, underlineText, resetCustomSectionStyle, resetStyles, showBanner } from '../public/helpers.js';
import { getMetasiteId } from '../public/getMetasiteId.js';
import { fireBIEvent } from '../public/BIEventsFunctions';
import * as CONSTS from '../public/consts.js';

import { getHomePagePosts, getCategoryPageData, getSiteCategories } from '@tikvas/marketingblogs-backend';

let baseUrl = '';
let isPostHelpfulActive = false;
let isPostHelpfulAnswered = false;

export async function initHomePage() {
    baseUrl = wixLocation.baseUrl;
    setResponsive('home');
    const homePagePosts = await getHomePagePosts();
    return setHomePagePosts(homePagePosts);
}

export async function initBlogPage() {
    setResponsive('blog');
    baseUrl = wixLocation.baseUrl;
    wixLocation.onChange(async () => {
        await initCategoryPage();
    })
    return initCategoryPage();
}

export async function initPostPage(requestId = '') {
    baseUrl = wixLocation.baseUrl;
    wixLocation.onChange(async () => {
        $w('#columnStripHeader').scrollTo();
        initPagePost(requestId);
    })
    await initPagePost(requestId);
}

export function initSubscribePage() {
    if (formFactor === "Mobile") {
        $w("#inputEmail").onClick((event) => {
            setTimeout(function () {
                $w("#subscribeForm").scrollTo()
                    .then(() => {
                        $w("#inputEmail").focus()
                    });
            }, 100)

        });
    }

    $w('#subscribeForm').onWixFormSubmitted(() => {
        const button_name = $w('#subscribeBtn').label || '';
        const biEventFields = {
            button_name,
            topic: 'Wix Blog',
            url: wixLocation.url
        }
        fireBIEvent(19, 402, biEventFields);
    })
}

export function initMasterPage() {
    if (formFactor === "Mobile") {
        $w("#mobileButtonCloseMenu").onClick(() => {
            $w("#menuContainer").close()
                .then(() => {
                    console.log("Menu is closed");
                });
        })

        $w('#buttonCreateAWebsite').link = "https://users.wix.com/signin?utm_campaign=bd_blog&experiment_id=it_all_cta&loginDialogContext=signup&overrideLocale=it&forceRender=true"
    }
    if (rendering.env === "browser") {
        if ($w("#getSubscribers1").onWixFormSubmit) {
            $w('#getSubscribers1').onWixFormSubmit(() => {
                $w("#columnStripSubscribe").scrollTo();
            })

            $w("#getSubscribers1").onWixFormSubmitted((formDetails) => {
                $w("#columnStripSubscribe").scrollTo();
                const button_name = $w('#buttonJoinNewsletter').label || '';
                const biEventFields = {
                    button_name,
                    topic: 'Wix Blog',
                    url: wixLocation.url
                }
                fireBIEvent(19, 402, biEventFields);
            });
        }

        showBanner();
    }
}

//home page functions///
function setHomePagePosts(homePagePosts) {
    let mainPosts = [],
        mainFeaturedPost = {},
        secFeaturedPost = {},
        category1Posts = [],
        category2Posts = [],
        category3Posts = [];
    const websiteEssentialsTitle = $w('#websiteEssentialsTitle').text;
    const businessStrategiesTitle = $w('#businessStrategiesTitle').text;
    const editorsPickTitle = $w('#editorsPickTitle').text;
    
    let i = 0,
        length = homePagePosts.length;
    while (i < length) {
        const { category = '', posts = [] } = homePagePosts[i] || {};

        switch (category.toLowerCase()) {
        case 'Home Main Posts'.toLowerCase():
            mainPosts = posts;
            break;
        case 'Main Featured Post'.toLowerCase():
            mainFeaturedPost = posts[0];
            break;
        case 'Secondary Featured Post'.toLowerCase():
            secFeaturedPost = posts[0];
            break;
        case `${editorsPickTitle} on Home Page`.toLowerCase():
            category1Posts = posts;
            break;
        case `${websiteEssentialsTitle} on Home Page`.toLowerCase():
            category2Posts = posts;
            break;
        case `${businessStrategiesTitle} on Home Page`.toLowerCase():
            category3Posts = posts;
            break;
        default:
            break;
        }
        i++;
    }

    i = 0;
    length = mainPosts.length;
    while (i < length) {
        assignHomePostDataToUI(`post${i+1}`, mainPosts[i]);
        i++;
    }
    assignHomePostDataToUI('mainPost', mainFeaturedPost);
    assignHomePostDataToUI('secPost', secFeaturedPost);
    setHomeCustomSections([category1Posts, category2Posts, category3Posts]);
    return;
}

function assignHomePostDataToUI(type, post) {
    const {
        title = '',
            mainCategoryLabel = '',
            mainCategoryUrl = '',
            postPageUrl = '',
            coverImage = '',
            excerpt = ''
    } = post || {};
    $w(`#${type}Title`).text = title;
    linkText($w(`#${type}Title`), baseUrl + postPageUrl)
    $w(`#${type}Category`).text = mainCategoryLabel.toUpperCase();
    let fullCategoryPageUrl = baseUrl + CONSTS.categoryPath.concat(mainCategoryUrl.split('/')[2]);
    linkTextInner($w(`#${type}Category`), fullCategoryPageUrl)
    $w(`#${type}Category`).show();
    if (['mainPost', 'secPost'].includes(type)) {
        $w(`#${type}Description`).text = excerpt;
        linkTextInner($w(`#${type}Description`), baseUrl + postPageUrl);
        $w(`#${type}Btn`).link = postPageUrl;
    }
    if (formFactor === 'Mobile' && !['mainPost', 'secPost'].includes(type)) {
        $w(`#${type}Image`).src = coverImage;
        $w(`#${type}ImageBox`).onClick(() => {
            wixLocation.to(postPageUrl);
        })
        $w(`#${type}Image`).alt = title
    } else {
        $w(`#${type}Column`).background.src = coverImage;
        $w(`#${type}Column`).background.alt = title;
        $w(`#${type}Column`).alt = title;
        $w(`#${type}Column`).onClick(() => {
            wixLocation.to(postPageUrl);
        });
        $w(`#${type}Column`).onMouseIn(() => {
            runOpacityHoverEffect($w(`#${type}Column`), 0.8)
            resetStyles(type, 'opacity')
        });
        $w(`#${type}Column`).onMouseOut(() => {
            runOpacityHoverEffect($w(`#${type}Column`), 1)
            resetStyles(type, 'opacity')
        });
        $w(`#${type}Category`).onMouseIn(() => {
            const isSecPost = type === 'secPost';
            changeTextColor($w(`#${type}Category`), CONSTS.colors.blue, isSecPost)
            resetStyles(type, 'color')
        })
        $w(`#${type}Category`).onMouseOut(() => {
            const color = type === 'secPost' ? CONSTS.colors.white : CONSTS.colors.black;
            changeTextColor($w(`#${type}Category`), color)
            resetStyles(type, 'color')

        })
        $w(`#${type}Title`).onMouseIn(() => {
            underlineText($w(`#${type}Title`), true)
            resetStyles(type, 'underline')
        });
        $w(`#${type}Title`).onMouseOut(() => {
            underlineText($w(`#${type}Title`), false)
            resetStyles(type, 'underline')
        });
    }

}

function setHomeCustomSections(customPostsArr) {
    setHomeCustomSectionPosts($w('#editorsPicksColumns'), $w('#editorsPickData'), customPostsArr[0]);
    setHomeCustomSectionPosts($w('#websiteEssentialsColumns'), $w('#websiteEssentialsData'), customPostsArr[1]);
    setHomeCustomSectionPosts($w('#businessStrategiesColumns'), $w('#businessStrategiesData'), customPostsArr[2]);
    return
}

function setHomeCustomSectionPosts(postsColumnsContainers, postsDataContainers, customPosts) {
    let postsImages = postsColumnsContainers && postsColumnsContainers.children;
    let postsDataTexts = postsDataContainers.children.map(child => child.children[0]);
    let postsBoxes;
    if (formFactor === 'Mobile') {
        postsImages = postsDataContainers.children.map(child => child.children[0].children[0]);
        postsBoxes = postsDataContainers.children.map(child => child.children[0]);
        postsDataTexts = postsDataContainers.children.map(child => child.children[1]);
    }
    customPosts.forEach((post, index) => {
        const { title = '', postPageUrl = '', coverImage = '' } = post || {};

        if (formFactor === 'Mobile') {
            postsImages[index].src = coverImage;
            postsBoxes[index].onClick(() => {
                wixLocation.to(postPageUrl);
            });
            postsImages[index].alt = title
        } else {
            postsImages[index].background.src = coverImage;
            postsImages[index].background.alt = title;
            postsImages[index].onClick(() => {
                wixLocation.to(postPageUrl);
            })
            postsImages[index].onMouseIn(() => {
                runOpacityHoverEffect(postsImages[index], 0.8)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'opacity')
            }).onMouseOut(() => {
                runOpacityHoverEffect(postsImages[index], 1)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'opacity')
            })
            postsDataTexts[index].onMouseIn(() => {
                underlineText(postsDataTexts[index], true)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'underline')
            });
            postsDataTexts[index].onMouseOut(() => {
                underlineText(postsDataTexts[index], false)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'underline')
            });
        }

        postsDataTexts[index].text = title;
        linkText(postsDataTexts[index], baseUrl + postPageUrl)
    })
    formFactor !== 'Mobile' && postsColumnsContainers.show();
    postsDataContainers.show();
}

//blog page functions///
async function initCategoryPage() {
    const { error, items: siteCategories } = await getSiteCategories();
    if (error) console.error('>> Failed fetching site categories', error);

    const categoryData = Object.values(siteCategories).find(item => {
        return item.categoryPageUrl && wixLocation.url.includes(item.categoryPageUrl.split('/')[2])
    });
    const categoryId = Object.keys(siteCategories).find(key => siteCategories[key] === categoryData);
    if (!categoryId) console.error('getCategoryPageData', { siteCategories, categoryData, url: wixLocation.url})
    const { label = '', } = categoryData || {};

    fireCategoryPageLoadBiEvent(categoryId, label)

    const pageNumber = getPageNumber()

    if (pageNumber > 1) {
        $w('#categoryTitle').text = paginateCategoryTitle(label, pageNumber)
        await categoryPageDataElements.delete()
    } else {
        $w('#categoryTitle').text = label
        await categoryPageDataElements.restore()
        await setCategoryPageData(categoryId)
    }
}

const paginateCategoryTitle = (label, pageNumber) => {
    const pageTranslations = {
        'en': 'Page',
        'fr': 'Page',
        'it': 'Pagina',
        'es': 'Página'
    }
    const pageTranslated = pageTranslations[wixSite.language] || pageTranslations['en']
    const pageSuffix = `(${pageTranslated} ${pageNumber})`

    return `${label} ${pageSuffix}`
}

const fireCategoryPageLoadBiEvent = async (categoryId, label) => {
    if (rendering.env !== "browser") return

    const newMsid = await getMetasiteId()

    const biEventFields = {
        app_id: '',
        biToken: newMsid,
        category_id: categoryId,
        category_name: label,
        origin: 'categories_page',
        referral_info: referrer,
    }

    fireBIEvent(69, 201, biEventFields)
}

const getPageNumber = () => {
    const pagePathIndex = wixLocation.path.findIndex(pathPart => pathPart === 'page')
    if (pagePathIndex === -1) return 1
    return parseInt(wixLocation.path[pagePathIndex + 1]) || 1
}

const categoryPageDataElements = {
    elements: [
        '#categoryDescription',
        '#startNowBunner',
        '#lineStrip',
        '#mostPopularTitleStrip',
        '#mostPopularImages', // desktop only
        '#mostPopularData',
        '#mostPopTableSpace',
        '#tableStrip',
        '#tableMustReadSpace',
        '#mustReadTitleStrip',
        '#mustReadImages', // desktop only
        '#mustReadData',
    ],
    delete: function () {
        const deletePromises = []
        this.elements.forEach(elementId => {
            const $element = $w(elementId)
            if ($element.delete && !$element.deleted) deletePromises.push($element.delete())
        })
        return Promise.all(deletePromises)
    },
    restore: function () {
        const restorePromises = []
        this.elements.forEach(elementId => {
            const $element = $w(elementId)
            if ($element.restore && $element.deleted) restorePromises.push($element.restore())
        })
        return Promise.all(restorePromises)
    }
}

async function setCategoryPageData(categoryId) {
    const categoryPageData = await getCategoryPageData(categoryId);
    const { mostPopularPosts = [], mustReadPosts = [], description = '', bannerLink = '' } = categoryPageData || {};
    $w('#categoryDescription').text = description;
    $w('#startNowBtn').link = bannerLink;
    $w('#startNowBtn').target = '_self';
    let mostPopularImages = [];
    let mustReadImages = [];
    let mostPopularBoxes = [],
        mustReadBoxes = [];
    let mostPopularData = $w('#mostPopularData').children.map(child => child.children[0]);
    let mustReadData = $w('#mustReadData').children.map(child => child.children[0]);
    if (formFactor === 'Mobile') {
        mostPopularImages = $w('#mostPopularData').children.map(child => child.children[0].children[0]);
        mustReadImages = $w('#mustReadData').children.map(child => child.children[0].children[0]);
        mostPopularData = $w('#mostPopularData').children.map(child => child.children[1]);
        mustReadData = $w('#mustReadData').children.map(child => child.children[1]);
        mostPopularBoxes = $w('#mostPopularData').children.map(child => child.children[0]);
        mustReadBoxes = $w('#mustReadData').children.map(child => child.children[0]);
    } else {
        mostPopularImages = $w('#mostPopularImages').children;
        mustReadImages = $w('#mustReadImages').children;
    }

    setCategoryCustomPosts(mostPopularPosts, mostPopularImages, mostPopularData, mostPopularBoxes);
    setCategoryCustomPosts(mustReadPosts, mustReadImages, mustReadData, mustReadBoxes);
}

function setCategoryCustomPosts(customPosts, postsImagesColumns, postsDataTexts, postsImagesContainers) {
    customPosts.forEach((post, index) => {
        const { title = '', postPageUrl = '', coverImage = '' } = post || {};
        if (postsImagesColumns[index].background) {
            postsImagesColumns[index].background.src = coverImage;
            postsImagesColumns[index].background.alt = title;
            postsImagesColumns[index].onClick(() => {
                wixLocation.to(postPageUrl);
            })
        } else {
            postsImagesColumns[index].src = coverImage;
            postsImagesColumns[index].alt = title;
            postsImagesContainers[index].onClick(() => {
                wixLocation.to(postPageUrl)
            })
        }

        postsDataTexts[index].text = title;

        linkText(postsDataTexts[index], baseUrl + postPageUrl);

        if (formFactor !== 'Mobile') {
            postsImagesColumns[index].onMouseIn(() => {
                runOpacityHoverEffect(postsImagesColumns[index], 0.8)
                resetCustomSectionStyle(postsDataTexts, postsImagesColumns, index, 'opacity')
            })
            postsImagesColumns[index].onMouseOut(() => {
                runOpacityHoverEffect(postsImagesColumns[index], 1)
                resetCustomSectionStyle(postsDataTexts, postsImagesColumns, index, 'opacity')
            })
            postsDataTexts[index].onMouseIn(() => {
                underlineText(postsDataTexts[index], true)
                resetCustomSectionStyle(postsDataTexts, postsImagesColumns, index, 'underline')
            })
            postsDataTexts[index].onMouseOut(() => {
                underlineText(postsDataTexts[index], false)
                resetCustomSectionStyle(postsDataTexts, postsImagesColumns, index, 'underline')
            })

        }
    })

    $w("#mostPopularImages").rendered && $w("#mostPopularImages").hidden && $w('#mostPopularImages').show();
    $w('#mostPopularData').show();
    $w("#mustReadImages").rendered && $w("#mustReadImages").hidden && $w('#mustReadImages').show();
    $w('#mustReadData').show();
}

//post page functions///
function initPagePost(requestId = '') {
    if (formFactor !== "Mobile") {
        //show and hide social icons
        // $w("#columnStripQ").onViewportLeave((event) => {
        //     $w("#boxSocialShare").show();
        // });

        // $w("#columnStripQ").onViewportEnter((event) => {
        //     $w("#boxSocialShare").hide()
        // });
        // $w("#columnStripSpace").onViewportEnter((event) => {
        //     $w("#boxSocialShare").hide();
        // });
        // $w("#footer").onViewportEnter((event) => {
        //     $w("#boxSocialShare").hide();
        // });
        $w("#footer").onViewportLeave((event) => {
            $w("#boxSocialShare").show('float', { 'duration': 200, direction: 'left' })
        });
        $w("#footer").onViewportEnter((event) => {
            $w("#boxSocialShare").hide('float', { 'duration': 200, direction: 'left' })
        });
        $w('#copyIcon').onClick(() => {
            copyToClipboard(wixLocation.url)
            $w('#textCopyLink').show()
                .then(() => {
                    setTimeout(function () {
                        $w('#textCopyLink').hide()
                    }, 2000)
                });
        })
    }
    $w("#yesHelpfulBtn").onClick(() => {
        $w("#yesHelpfulBtn").style.backgroundColor = CONSTS.colors.black;
        $w("#yesHelpfulBtn").style.color = CONSTS.colors.white;
        $w("#notHelpfulBtn").style.backgroundColor = CONSTS.colors.white;
        $w("#notHelpfulBtn").style.color = CONSTS.colors.black;
        const postPageUrl = wixLocation.url;
        const buttonLabel = $w("#yesHelpfulBtn").label;
        const biEventFields = {
            app_url: postPageUrl,
            button_text: buttonLabel
        }
        fireBIEvent(19, 401, biEventFields);
        isPostHelpfulActive = true;
        isPostHelpfulAnswered = true;
    })
    $w('#yesHelpfulBtn').onMouseIn(() => {
        if (!isPostHelpfulActive) {
            $w('#yesHelpfulBtn').style.backgroundColor = CONSTS.colors.black;
            $w("#yesHelpfulBtn").style.color = CONSTS.colors.white;
        }
    }).onMouseOut(() => {
        if (!isPostHelpfulActive) {
            $w('#yesHelpfulBtn').style.backgroundColor = CONSTS.colors.white;
            $w("#yesHelpfulBtn").style.color = CONSTS.colors.black;
        }
    })
    $w('#notHelpfulBtn').onMouseIn(() => {
        if (isPostHelpfulActive || !isPostHelpfulAnswered) {
            $w('#notHelpfulBtn').style.backgroundColor = CONSTS.colors.black;
            $w("#notHelpfulBtn").style.color = CONSTS.colors.white;
        }
    }).onMouseOut(() => {
        if (isPostHelpfulActive || !isPostHelpfulAnswered) {
            $w('#notHelpfulBtn').style.backgroundColor = CONSTS.colors.white;
            $w("#notHelpfulBtn").style.color = CONSTS.colors.black;
        }
    })

    $w("#notHelpfulBtn").onClick(() => {
        $w("#notHelpfulBtn").style.backgroundColor = CONSTS.colors.black;
        $w("#notHelpfulBtn").style.color = CONSTS.colors.white;
        $w("#yesHelpfulBtn").style.backgroundColor = CONSTS.colors.white;
        $w("#yesHelpfulBtn").style.color = CONSTS.colors.black;
        const postPageUrl = wixLocation.url;
        const buttonLabel = $w("#notHelpfulBtn").label;
        const biEventFields = {
            app_url: postPageUrl,
            button_text: buttonLabel
        }
        fireBIEvent(19, 401, biEventFields);
        isPostHelpfulActive = false;
        isPostHelpfulAnswered = true;
    })
    if (formFactor !== "Mobile") {
        $w("#postMainCategory").onMouseIn(() => {
            changeTextColor($w("#postMainCategory"), CONSTS.colors.blue)
        });
        $w("#postMainCategory").onMouseOut(() => {
            changeTextColor($w("#postMainCategory"), CONSTS.colors.black)
        });
    }
    return assignCategoryPostDataToUI(requestId);

}

async function assignCategoryPostDataToUI(requestId = '') {
    try {
        // if (requestId) console.log('1 assignCategoryPostDataToUI', { requestId })
        const [siteCategories, postData] = await Promise.all([getSiteCategories(requestId), $w('#post').getPost()]);
        // if (requestId) console.log('6 assignCategoryPostDataToUI new', { requestId, siteCategories })
        const { title = '', postPageURL = '', coverImage } = postData || {};
        // const { title = '', postPageURL = '', coverImage, mainCategory = "" } = postData || {};
        let mainCategory = postData.mainCategory
        if (!mainCategory) {
            const postId = postData._id || postData.id
            mainCategory = await wixData.get('Blog/Posts', postId)
                .then(({ mainCategory }) => mainCategory)
        }
        $w('#postTitle').text = title;
        let postMainCategory = siteCategories.items[mainCategory] || {};
        const { label = '', categoryPageUrl = '#' } = postMainCategory || {};
        $w('#postMainCategory').text = label.toUpperCase();

        linkTextInner($w('#postMainCategory'), baseUrl + CONSTS.categoryPath.concat(categoryPageUrl.split('/')[2]));
        if (formFactor !== 'Mobile') {
            setSocialShareLinks(title, postPageURL, coverImage)
        }
    } catch (err) {
        console.log('error in post page');
        console.error(err);
    }
}

async function setSocialShareLinks(title, url, image) {
    let wixImageURL = "";
    wixImageURL = "https://static.wixstatic.com/media/";
    let wixLocalURL = "";
    wixLocalURL = image && image.replace('wix:image://v1/', '') || '';
    wixLocalURL = wixLocalURL.substr(0, wixLocalURL.lastIndexOf('/'));
    const imageUrl = wixImageURL + wixLocalURL;
    const shareURL = encodeURI(wixLocation.url);
    $w('#facebookIcon').link = `https://www.facebook.com/sharer.php?u=${shareURL}&quote=${title}`;
    $w('#twitterIcon').link = `https://www.twitter.com/intent/tweet?url=${shareURL}&text=${title}`;

    const articleUrl = encodeURIComponent(shareURL);
    const articleTitle = encodeURIComponent(title);
    const articleSummary = encodeURIComponent(title);
    const articleSource = encodeURIComponent('wix.com');
    const linkedinLink = 'http://www.linkedin.com/shareArticle?mini=true' +
        '&url=' + articleUrl +
        '&title=' + articleTitle +
        '&summary=' + articleSummary +
        '&source=' + articleSource;
    $w('#linkedinIcon').link = linkedinLink;
}

//general///
function setResponsive(page) {
    if (formFactor === "Desktop") {
        let fontSizeTitleH3 = 1.5;
        let fontSizeTitle = 2.5;
        let widthH3 = 27;
        makeResponsive("#post1Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        makeResponsive("#post2Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        makeResponsive("#post3Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        makeResponsive("#post4Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        makeResponsive("#post5Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        makeResponsive("#post6Title", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        if (page == 'home') {
            makeResponsive("#mainPostTitle", "h1", fontSizeTitle, CONSTS.colors.black, 1.1, null, 30, "left");
            makeResponsive("#secPostTitle", "h2", fontSizeTitle, CONSTS.colors.white, 1.1, null, null, "center");
            makeResponsive("#text55", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text53", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text51", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text23", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text20", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text21", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text46", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text44", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
            makeResponsive("#text42", "h3", fontSizeTitleH3, CONSTS.colors.black, 1.3, null, widthH3, "left");
        }
    }
}